import { schCompType, schFilledAddress, schZipCode } from '@aloft/toolkit-shared';

import { UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { schMlsListingInfo } from '../../../../components/MLSInput/types.ts';

export type CompEntryType = 'mls' | 'address';

const requiredString = z.string().min(1);

export const schCompEntry = z.discriminatedUnion('method', [
  z.strictObject({
    method: z.literal('mls'),
    mls: schMlsListingInfo.shape.mls,
    mlsListingID: schMlsListingInfo.shape.mlsListingID,
  }),
  z.strictObject({
    method: z.literal('address'),
    AddressLineText: requiredString,
    unitNumber: schFilledAddress.shape.unitNumber,
    CityName: requiredString,
    StateCode: requiredString,
    PostalCode: schZipCode,
  }),
]);

export type CompEntry = z.infer<typeof schCompEntry>;

export const schAddComparablesForm = z.strictObject({
  entries: z.array(schCompEntry),
  compType: schCompType.optional(),
});

export type AddComparablesForm = z.infer<typeof schAddComparablesForm>;

export type AddCompsFormProps = {
  form: UseFormReturn<
    z.input<typeof schAddComparablesForm>,
    unknown,
    z.infer<typeof schAddComparablesForm>
  >;
};
